// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../differenceInMinutes/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var differenceInMinutes = convertToFP(fn, 2);
export default differenceInMinutes;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/differenceInMinutes/index.js
// module id = 839
// module chunks = 0